import { validationMessages } from './validationMessages.schema';

export default {
  title: 'Struktura',
  type: 'object',
  properties: {
    name: {
      title: 'Nazwa struktury',
      type: 'string',
      fieldRequired: true
    },
    order: {
      title: 'Kolejność (wprowadź liczbę oznaczającą miejsce zespołu na liście szkół)',
      type: 'integer',
      fieldRequired: false
    },
    epuap: {
      title: 'Adres skrytki ePUAP',
      type: 'string',
      fieldRequired: false,
      validFunc: '!$value || /\\/.+\\/.+/.test($value)',
      validationMessages: {
        validFunc: 'Należy podać prawidłowy adres skrytki ePUAP, w formacie "/login_w_epuap/nazwa_skrytki"'
      }
    },
    isGuided: {
      title: 'Czy jednostka jest prowadzona przez gminę Lublin?',
      type: 'boolean',
      enum: [true, false]
    },
    isSchool: {
      title: 'Czy jednostka jest szkołą?',
      type: 'boolean',
      enum: [true, false, null],
      calc: '!!this.data.reportType && this.data.reportType !== "Kolegium"'
    },
    isCollege: {
      title: 'Czy jednostka jest kolegium?',
      type: 'boolean',
      enum: [true, false, null],
      calc: 'this.data.reportType === "Kolegium"'
    },
    integrationCodeOverwrite: {
      title: 'Kod integracyjny dla aplikacji Witkac',
      type: 'string'
    },
    parentId: {
      type: 'number',
      fieldRequired: false
    },
    bankAccountNumber: {
      fieldRequired: false,
      format: 'iban',
      title: 'Numer rachunku bankowego',
      type: 'string'
    },
    regon: {
      fieldRequired: false,
      title: 'Numer REGON',
      type: 'string'
    },
    data: {
      title: 'Dane jednostki',
      type: 'object',
      properties: {
        reportType: {
          title: 'Rodzaj jednostki',
          type: 'string'
        },
        code: {
          title: 'Kod jednostki',
          type: 'string'
        },
        level: {
          title: 'Poziom szkoły',
          type: 'number'
        },
        address: {
          title: 'Adres jednostki',
          type: 'object',
          properties: {
            email: {
              title: 'Adres e-mail',
              type: 'string',
              fieldRequired: true,
              format: 'email'
            },
            terc: {
              title: 'Kod TERC',
              type: 'string',
              fieldRequired: true
            },
            woj: {
              title: 'Województwo - kod',
              type: 'string',
              fieldRequired: true,
              calc: 'this.terc && this.terc.substr(0, 2)'
            },
            wojName: {
              title: 'Województwo',
              type: 'string',
              fieldRequired: true
            },
            pow: {
              title: 'Powiat - kod',
              type: 'string',
              fieldRequired: true,
              calc: 'this.terc && this.terc.substr(2, 2)'
            },
            powName: {
              title: 'Powiat',
              type: 'string',
              fieldRequired: true
            },
            gmi: {
              title: 'Gmina',
              type: 'string',
              fieldRequired: true,
              calc: 'this.terc && this.terc.substr(4, 2)'
            },
            gmiName: {
              title: 'Gmina - kod',
              type: 'string',
              fieldRequired: true
            },
            simc: {
              title: 'Miejscowość',
              type: 'string'
            },
            city: {
              title: 'Miejscowość',
              type: 'string',
              fieldRequired: true
            },
            postalCode: {
              title: 'Kod pocztowy',
              type: 'string',
              fieldRequired: true
            },
            ulic: {
              title: 'Ulica',
              type: 'string',
              fieldRequired: true
            },
            street: {
              title: 'Ulica',
              type: 'string',
              fieldRequired: true
            },
            houseNumber: {
              title: 'Numer budynku',
              type: 'string',
              fieldRequired: true
            },
            flatNumber: {
              title: 'Numer lokalu',
              type: 'string'
            }
          }
        }
      }
    }
  },
  allOf: [validationMessages]
};
